import * as UIUtil from "/app/js/util/UI.js";
import {getNoticeList} from "../api/NoticeApi.js";
import {PAGE_OPT, SEARCH_OPT} from "../config/NoticeConfig.js";
import {rendererPageInfo} from "../../util/Page.js";
import * as _NoticeDetail from "/app/js/notice/panel/NoticeDetail.js";
import {getActiveMenuKey, getKeyMenuByParent, getParentKey, openMenu} from "../../common/Menu.js";

const PAGE = PAGE_OPT.LIST;
const SEARCH = SEARCH_OPT.LIST;
let fullNoticeList = [];

export const open = async function (pushHistory = true) {
    try {
        // 히스토리 업데이트 (목록으로 돌아올 때)
        if (pushHistory && location.hash !== '#Notice') {
            history.pushState({ menuKey: 'Notice' }, '', '#Notice');
        }

        document.querySelector(".banner")?.remove();
        document.querySelector("section.contents-wrap")?.remove();

        const lang = document.documentElement.lang || 'ko';
        const htmlUrl = `app/html/${lang}/prcenter/Notice.html`;

        const headerWrap = document.querySelector(".headerWrap");

        const response = await fetch(htmlUrl);
        const html = await response.text();

        headerWrap.insertAdjacentHTML("afterend", html);

        initEvent();
        initTabs();
        initSearchEvent();
        await drawList();

    } catch (error) {
        console.error(error);
    }
};

const initEvent = function () {
    const homeElement = document.querySelector('.breadcrumb .home');

    if (homeElement) {
        homeElement.addEventListener('click', () => {
            openMenu('Main');
        });
    }
}

const initTabs = function () {
    const tabLinks = document.querySelectorAll(".tabArea .subtabs li a");
    if (!tabLinks.length) return;

    tabLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            const li = link.parentElement;
            if (!li || li.classList.contains("on")) return;

            document.querySelectorAll(".tabArea .subtabs li").forEach(item => item.classList.remove("on"));
            li.classList.add("on");

            SEARCH.category = link.dataset.category || null;
            drawList(1);
        });
    });
};

const drawList = async function (pageNo = 1) {
    PAGE.pageNo = pageNo;

    const param = {
        ...SEARCH,
        rowSize: PAGE.pg_rowsize,
        currentPage: PAGE.pageNo
    };

    const response = await getNoticeList(param);

    if (!response.SUCCESS) {
        UIUtil.msgBox("검색 실패", "error");
        return;
    }

    const { LIST, TOTAL_COUNT } = response.RESULT;
    fullNoticeList = LIST;

    drawListItems(LIST);
    drawTotalCount(TOTAL_COUNT);
    const pageOption = {
        ...PAGE,
        domId: ".paginate",
        pdom: ".paginate-wrap",
        totalCount: TOTAL_COUNT
    };

    rendererPageInfo(pageOption, drawList);
};

const drawListItems = function (items) {
    const listEl = document.querySelector(".tabArea .contents .board-list ul");
    if (!listEl) return;
    listEl.innerHTML = "";

    if (!items || items.length === 0) {
        listEl.innerHTML = `<li class="empty"><a>등록된 공지사항이 없습니다.</a></li>`;
        return;
    }

    items.forEach((item) => {
        const li = document.createElement("li");

        li.innerHTML = `
            <a>
                <p class="cte-cnt">
                    <span class="category">${item.category ?? "기타"}</span>
                    <span class="date">${item.registerDate}</span>
                </p>
                <div class="con-cnt">
                    <h2>${item.title}</h2>
                </div>
            </a>
        `;
        li.addEventListener("click", () => {
            _NoticeDetail.open(item.noticeId);
        });

        listEl.appendChild(li);
    });
};

const drawTotalCount = function (count) {
    const strong = document.querySelector(".tabArea .contents > .total strong");
    if (strong) strong.textContent = count ?? 0;
};

const initSearchEvent = function () {
    const searchInput = document.querySelector(".search-box input[type='search']");
    const searchBtn = document.querySelector(".search-box button");

    if (!searchInput || !searchBtn) return;

    searchBtn.addEventListener("click", function () {
        const keyword = searchInput.value.trim();
        SEARCH.searchValue = keyword;

        drawList(1);
    });

    searchInput.addEventListener("keypress", function (e) {
        if (e.key === "Enter") {
            searchBtn.click();
        }
    });
};
